import Home from "./components/Home"
import About from "./components/About"
import Contact from "./components/Contact"
import Profile from "./components/Profile"
import Leaderboard from "./components/Leaderboard"
import Login from "./components/Login"
import Performance from "./components/Performance"
import PerformanceDetails from "./components/PerformanceDetails"
export const allRoutes = [
    { path: '/', element: <Home /> },
    { path: '/about', element: <About /> },
    { path: '/contact', element: <Contact /> },
    { path: '/profile', element: <Profile /> },
    { path: '/leaderboard', element: <Leaderboard /> },
    { path: '/login', element: <Login /> },
    { path: '/performance', element: <Performance /> },
    { path: '/performanceDetails', element: <PerformanceDetails /> },

]